import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_CLUSTERS_INFO,
	GET_SITE_LIST_DATES
} from '../actions/HostToolsActions';

const initialState = {
	clustersInfo: [],
	siteListDates: [],
	formState: {
		values: {
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const hostToolsReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: []
						};
					}
					case GET_CLUSTERS_INFO: {
						return {
							...state,
							clustersInfo: action.clustersInfo
						};
					}
					case GET_SITE_LIST_DATES: {
						return {
							...state,
							siteListDates: action.siteListDates
						};
					}
					default: {
						return state;
					}
	}
};

export default hostToolsReducer;
